import React from "react";

import useViewport from "components/general/useViewPort";
import { isCombinedBoulder, isBoulderKRA, isCombinedLead, isSpeedSeeding, isSpeedQualification, isSpeedFinal, isLeadKRA } from "components/sports/clb/helper/ClbHelpers";
import ClbBoulderBoulder from "components/sports/clb/views/ClbBoulderBoulder";
import ClbBoulderLead from "components/sports/clb/views/ClbBoulderLead";
import ClbSpeedSeeding from "components/sports/clb/views/ClbSpeedSeeding";
import ClbSpeedQualification from "components/sports/clb/views/ClbSpeedQualification";
import ClbSpeedFinal from "components/sports/clb/views/ClbSpeedFinal";
import ClbLeadQualification from "components/sports/clb/views/ClbLeadQualification"
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';

import 'styles/sports/clb.scss';

const ClbContext = () => {
  const { mirs_competition, mirs_rsc, mirs_language } = useUrlFriendlyToParameters()
  const { breakPoint } = useViewport();

  return (<>
    <div className="clb-main">
      { (isCombinedBoulder(mirs_rsc) || isBoulderKRA(mirs_rsc)) && 
      <ClbBoulderBoulder mirs_competition={mirs_competition} mirs_language={mirs_language} mirs_rsc={mirs_rsc} breakPoint={breakPoint} />
      }

      {isCombinedLead(mirs_rsc) && 
      <ClbBoulderLead mirs_competition={mirs_competition} mirs_language={mirs_language} mirs_rsc={mirs_rsc} breakPoint={breakPoint} />
      }
      
      { isSpeedSeeding(mirs_rsc) && 
      <ClbSpeedSeeding mirs_competition={mirs_competition} mirs_language={mirs_language} mirs_rsc={mirs_rsc} breakPoint={breakPoint} />
      }

      { isLeadKRA(mirs_rsc) && 
      <ClbLeadQualification mirs_competition={mirs_competition} mirs_language={mirs_language} mirs_rsc={mirs_rsc} breakPoint={breakPoint} />
      }

      { isSpeedQualification(mirs_rsc) && 
      <ClbSpeedQualification mirs_competition={mirs_competition} mirs_language={mirs_language} mirs_rsc={mirs_rsc} breakPoint={breakPoint} />
      }

      { isSpeedFinal(mirs_rsc) && 
      <ClbSpeedFinal mirs_competition={mirs_competition} mirs_language={mirs_language} mirs_rsc={mirs_rsc} breakPoint={breakPoint} />
      }      
    </div>
  </>);
};

export default ClbContext;
